module.exports = __webpack_public_path__ + "img/Immagine-BarraNav-v2.a35fbe35.jpg";